import actions from "~/shared/actions";
import type { Action } from "~/utils/actions";

export interface OpenInvestmentFund {
	fundName: string;
	fundType: string;
	isin: string | null;
	proportion: number;
	url: string;
	price: number;
	region: string;
}

type NewOpenInvestmentFund = Pick<OpenInvestmentFund, "isin" | "proportion">;

export interface InvestmentPrograms {
	[key: number]: {
		openInvestmentFunds?: OpenInvestmentFund[];
		newOpenInvestmentFunds?: NewOpenInvestmentFund[];
		newInvestmentProgram?: boolean;
		manualStepsRequired?: boolean;
	};
}

export const defaultState: InvestmentPrograms = {};

export default function investmentPrograms(state = defaultState, action: Action): InvestmentPrograms {
	switch (action.type) {
		case actions.OPEN_INVESTMENT_FUNDS_REQUEST: {
			return {
				...state,
				[action.data.polisenummer]: {
					...state[action.data.polisenummer],
				},
			};
		}
		case actions.OPEN_INVESTMENT_FUNDS_RESPONSE: {
			return {
				...state,
				[action.data.polisenummer]: {
					...state[action.data.polisenummer],
					openInvestmentFunds: action.data.openInvestmentFunds,
				},
			};
		}
		case actions.INVESTMENT_PROFILE_UPDATE_REQUEST: {
			return {
				...state,
				[action.data.polisenummer]: {
					...state[action.data.polisenummer],
				},
			};
		}
		case actions.OPEN_INVESTMENT_FUNDS_UPDATE_REQUEST: {
			return {
				...state,
				[action.data.polisenummer]: {
					...state[action.data.polisenummer],
				},
			};
		}
		case actions.INVESTMENT_PROFILE_UPDATE_RESPONSE: {
			return {
				...state,
				[action.data.polisenummer]: {
					...state[action.data.polisenummer],
					manualStepsRequired: action.data.manualStepsRequired,
					newInvestmentProgram: !!action.data.newInvestmentProgram,
				},
			};
		}
		case actions.OPEN_INVESTMENT_FUNDS_UPDATE_RESPONSE: {
			return {
				...state,
				[action.data.polisenummer]: {
					...state[action.data.polisenummer],
					newOpenInvestmentFunds: action.data.newOpenInvestmentFunds,
				},
			};
		}
		default:
			return state;
	}
}
